import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import { Box } from 'approot/shared/design-system/box/box.style';
import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import { ComponentResponse } from 'approot/activity-builder/components/component.constants';
import { useResponseBaseHeight } from 'approot/activity-builder/components/response/response.hooks';
import SubActivityView from 'approot/activity-builder/components/sub-activity/sub-activity-view';
import { getRichtextAnswer } from 'approot/activity-builder/components/shared/logic/get-richtext-answer';
import { getAnswerTypeLabel } from 'approot/activity-builder/components/suggested-answers/logic/get-answer-type-label';
import {
  ClassroomAnswerInstruction,
  ClassroomSuggestedAnswer,
} from '../classroom-answer.style';
import SuggestedAnswerResponseReadonly from 'approot/activity-builder/components/suggested-answers/shared/suggested-answer-field-readonly';

type Props = {
  component: Omit<ComponentResponse, '__typename'>;
};

const TextResponseSuggestedAnswers = ({
  component: { properties, subActivityProperties, suggestedAnswerProperties },
}: Props) => {
  const baseHeight = useResponseBaseHeight();

  const sortedFields = useMemo(
    () => sortBy(properties.textResponse.fields, 'sort'),
    [properties.textResponse.fields]
  );

  return (
    <ClassroomAnswerInstruction>
      <SubActivityView subActivityDetails={subActivityProperties}>
        <Box $flexDirection="column" $gap={8}>
          {sortedFields.map(field => {
            const answer = suggestedAnswerProperties?.suggestedAnswers?.find(
              sa => sa.answerReferences?.id === field.itemId
            );
            return (
              <ClassroomSuggestedAnswer key={field.itemId}>
                <Box $gap={8} $flexDirection="column">
                  <SuggestedAnswerResponseReadonly
                    key={field.itemId}
                    baseHeight={baseHeight}
                    field={field}
                    answer={getRichtextAnswer(answer)}
                  />
                  {suggestedAnswerProperties?.suggestedAnswerType && (
                    <BadgeSmallStyled>
                      {getAnswerTypeLabel(
                        suggestedAnswerProperties?.suggestedAnswerType
                      )}
                    </BadgeSmallStyled>
                  )}
                </Box>
              </ClassroomSuggestedAnswer>
            );
          })}
        </Box>
      </SubActivityView>
    </ClassroomAnswerInstruction>
  );
};

export default TextResponseSuggestedAnswers;
